export class Tooltip {

    private _label: string;
    private _content: string;
    private _disabledInfoIconTextVisibility: boolean;

    constructor(
        content: string = '',
        label: string = '',
        disabledInfoIconTextVisibility: boolean = false
    ) {
        this._label = label;
        this._content = content;
        this._disabledInfoIconTextVisibility = disabledInfoIconTextVisibility;
    }

    /**
     * Getter label
     */
    public get label(): string {
        return this._label;
    }

    /**
     * Getter content
     */
    public get content(): string {
        return this._content;
    }

    public get disabledInfoIconTextVisibility(): boolean {
        return this._disabledInfoIconTextVisibility;
    }

}